import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pricing-boxes',
  templateUrl: './pricing-boxes.component.html',
  styleUrls: ['./pricing-boxes.component.scss']
})
export class PricingBoxesComponent implements OnInit {

  @Input() pricingContent;
  constructor() { }

  ngOnInit() {
  }

}
